/**
 * Discriminator for appointment rules. Mirrors the backend `RuleType` enum;
 * the wire value is the named string (e.g. "TimeBasedRestriction").
 */
export enum AppointmentRuleType {
  TimeBasedRestriction = 'TimeBasedRestriction',
}

/** Display labels — always render via this map, never the raw enum value. */
export const appointmentRuleTypeLabels: Record<AppointmentRuleType, string> = {
  [AppointmentRuleType.TimeBasedRestriction]: 'Time-based restriction',
};

/**
 * Tolerates every wire representation of a rule type: the named string, a
 * numeric (or numeric-string) enum index, null/undefined, and unknown future
 * values — all collapse to the single rule type defined today. Extend the
 * known-value check when new rule types ship.
 */
export function normalizeAppointmentRuleType(value: unknown): AppointmentRuleType {
  if (typeof value === 'string' && Object.prototype.hasOwnProperty.call(appointmentRuleTypeLabels, value)) {
    return value as AppointmentRuleType;
  }
  return AppointmentRuleType.TimeBasedRestriction;
}
